import { useState, useEffect } from "react";

interface AccountExpiredModalProps {
  onClose?: () => void;
  reason?: "expired" | "not_started";
}

const AccountExpiredModal = ({
  onClose,
  reason = "expired",
}: AccountExpiredModalProps) => {
  const [visible, setVisible] = useState(false);
  const isNotStarted = reason === "not_started";

  useEffect(() => {
    setTimeout(() => setVisible(true), 50);
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(8, 10, 20, 0.75)",
        backdropFilter: "blur(6px)",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.3s ease",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          width: "100%",
          maxWidth: "460px",
          margin: "16px",
          overflow: "hidden",
          transform: visible
            ? "translateY(0) scale(1)"
            : "translateY(20px) scale(0.97)",
          transition: "transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)",
          boxShadow: "0 32px 80px rgba(0,0,0,0.18), 0 0 0 1px rgba(0,0,0,0.06)",
          fontFamily: "system-ui, sans-serif",
          padding: "36px",
          textAlign: "center",
        }}
      >
        {/* Icon */}
        <div
          style={{
            width: 56,
            height: 56,
            background: "#fff0f0",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
            border: "1px solid #ffd6d6",
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#e53e3e"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        {/* Title */}
        <h2
          style={{
            margin: "0 0 8px",
            fontSize: "20px",
            fontWeight: 700,
            color: "#111",
            letterSpacing: "-0.3px",
          }}
        >
          {isNotStarted ? "Subscription Not Active" : "Account Expired"}
        </h2>

        {/* Subtitle */}
        <p
          style={{
            margin: "0 0 24px",
            fontSize: "14px",
            color: "#666",
            lineHeight: 1.6,
          }}
        >
          {isNotStarted
            ? "Your subscription hasn't started yet."
            : "We're sorry for the inconvenience."}
        </p>

        {/* Error card */}
        <div
          style={{
            background: "#fff5f5",
            border: "1px solid #fed7d7",
            borderRadius: "10px",
            padding: "14px 16px",
            display: "flex",
            alignItems: "flex-start",
            gap: "12px",
            textAlign: "left",
            marginBottom: "8px",
          }}
        >
          <svg
            style={{ flexShrink: 0, marginTop: "2px" }}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#e53e3e"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <div>
            <p
              style={{
                margin: "0 0 2px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#c53030",
              }}
            >
              {isNotStarted ? "Subscription Not Active" : "Account Expired"}
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "13px",
                color: "#c53030",
                lineHeight: 1.5,
              }}
            >
              {isNotStarted
                ? "Your subscription period has not started yet. Please contact your administrator."
                : "Your subscription period has ended. Please contact your administrator for renewal."}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountExpiredModal;
